import { LogwoodPackageState } from '@/logwood/models/logwood-package-state'
import { HistoryPeriodType } from '@/logwood/models/history-period-type'
import moment from 'moment'

export default class LogwoodHistoryFilter {
  public state: LogwoodPackageState = LogwoodPackageState.OuterBearing
  public periodType: HistoryPeriodType = HistoryPeriodType.Date
  public start: string = moment().subtract(3, 'days').format('YYYY-MM-DD')
  public end: string = moment().format('YYYY-MM-DD')
}